module.exports = __webpack_public_path__ + "img/inco5Ac.3cee228d.png";